import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Info } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function ExplanationPanel() {
  const { t } = useT();
  return (
    <Accordion
      type="single"
      collapsible
      className="rounded-xl border border-[#272A35] bg-[#131620]/60"
      data-testid="explanation-panel"
    >
      <AccordionItem value="how" className="border-none">
        <AccordionTrigger className="px-4 sm:px-5 py-4 hover:no-underline">
          <span className="flex items-center gap-2 text-slate-200 text-sm sm:text-base">
            <Info className="h-4 w-4 text-[#D4AF37]" />
            {t("explanation.title")}
          </span>
        </AccordionTrigger>
        <AccordionContent className="px-4 sm:px-5 pb-5 text-sm text-slate-300 space-y-3 leading-relaxed">
          <p
            dangerouslySetInnerHTML={{
              __html: t("explanation.p1", { b1: "<strong>", b2: "</strong>" }),
            }}
          />
          <ul className="list-disc pl-5 space-y-1.5">
            <li>{t("explanation.li1")}</li>
            <li
              dangerouslySetInnerHTML={{
                __html: t("explanation.li2", {
                  b1: "<strong>",
                  b2: "</strong>",
                }),
              }}
            />
            <li>{t("explanation.li3")}</li>
            <li>{t("explanation.li4")}</li>
            <li>{t("explanation.li5")}</li>
          </ul>
          <p className="text-slate-400 text-xs pt-1">{t("explanation.note")}</p>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
